<script lang="ts" setup>
import { Swiper } from 'swiper/vue'
import { Pagination, Navigation } from 'swiper/modules'

const props = defineProps<{
  manualHeight?: boolean
  gaps?: boolean
  breakpoints?: { [key: number]: Record<string, number> }
}>()
const { isPerkuJavTheme, isTarpininke } = useTheme()
const swiperModules = [Navigation, Pagination]

const getSpaceBetween = (space: number) => {
  if (props.gaps) {
    return space
  }

  return isPerkuJavTheme || isTarpininke ? 0 : space
}

const swiperBreakpoints = props.breakpoints ?? {
  640: {
    slidesPerView: 2.5,
    spaceBetween: getSpaceBetween(8),
  },
  1025: {
    slidesPerView: 3,
    spaceBetween: getSpaceBetween(30),
  },
  1300: {
    slidesPerView: 4,
    spaceBetween: getSpaceBetween(30),
  },
}
</script>

<template>
  <div class="full-slider-component">
    <div class="full-slider m-auto max-w-[1692px] p-4 lg:mb-4">
      <ClientOnly>
        <Swiper
          :slides-per-view="1.5"
          :space-between="getSpaceBetween(8)"
          :modules="swiperModules"
          :breakpoints="swiperBreakpoints"
          :navigation="true"
          :pagination="{ clickable: true, dynamicBullets: true }"
          :watch-slides-progress="true"
          :threshold="5"
          :auto-height="props.manualHeight ? false : true"
          class="md:!pb-8">
          <slot name="sliderContent" />
        </Swiper>
      </ClientOnly>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.full-slider-component {
  max-width: 2320px;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style lang="postcss">
.full-slider {
  position: relative;

  .swiper {
    overflow: visible;
    user-select: none;
    padding-bottom: 2.5rem;

    .swiper-button-prev,
    .swiper-button-next {
      top: 45%;
      display: none;
    }

    .swiper-button-disabled {
      display: none;
    }

    .swiper-pagination {
      bottom: 0;
    }

    .swiper-slide {
      opacity: 0.5;
      height: auto;

      &-visible {
        opacity: 1;
      }
    }
  }

  @media screen and (min-width: 1025px) {
    .swiper {
      margin: 0 66px;
      position: initial;

      .swiper-button-prev,
      .swiper-button-next {
        display: flex;
      }

      .swiper-button-disabled {
        display: none;
      }
    }
  }
}

.alt .full-slider .swiper {
  .swiper-slide {
    &:first-child {
      .product-slider-card {
        border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important;
      }
    }

    &:last-child {
      .product-slider-card {
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important;
      }
    }
  }
}
</style>
